"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultMaxPageSize = void 0;
const pagingMode_1 = require("./pagingMode");
exports.DefaultMaxPageSize = {
    [pagingMode_1.PagingMode.Offset]: 1000,
    [pagingMode_1.PagingMode.Cursor]: 100
};
//# sourceMappingURL=defaultMaxPageSize.js.map